import { ConfigService } from '../../../services/config.service';

import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { ScrAuthenticationService } from 'src/app/services/authentication.service';
import { PasswordRequest } from 'src/app/models/account.model';
import { ScrBaseComponent } from '../../base.component';
import { ScrServiceManager } from 'src/app/services/servicemanager.service';
import { NgControl, NgForm } from '@angular/forms';
import { Observable, of } from 'rxjs';
import { CreateAccountService } from 'src/app/services/createaccount.service';


@Component({
  templateUrl: './credentials.component.html',
  styleUrls: ['./credentials.component.scss']
})
export class CredentialsComponent extends ScrBaseComponent implements OnInit {

  public model: PasswordRequest = new PasswordRequest();
  public userIdOrEmail?: string;
  public JSON = JSON;
  public submitted = false;
  public customerSupportLink?: string;
  public confirmPasswordFocused = false;
  public token?: string;
  public userId?: string;
  public showForgotForm?: boolean = false;
  public showNoUserForm?: boolean = false;
  public showSpinner = false;
  public isIdAvailable = false;
  public dummy: { password?: string } = { password: '' };
  @ViewChild('createCredentialsForm', { static: false }) form!: NgForm;

  constructor(
    private authenticateService: ScrAuthenticationService,
    private scrServiceManager: ScrServiceManager,
    private configService: ConfigService,
    private logger: NGXLogger,
    private router: Router,
    public createAccountService: CreateAccountService,
    private route: ActivatedRoute) {
    super();

    this.configService.getConfig().subscribe(rsp => {
      this.customerSupportLink = rsp.customerSupportLink;
    });
  }

  ngOnInit(): void {
    this.token = this.route.snapshot.params.token;
    if (this.token) {
      this.model.token = this.token;
      this.validateToken();
    }
  }

  focusConfirmPassword() {
    this.confirmPasswordFocused = true;
  }

  blurConfirmPassword() {
    this.confirmPasswordFocused = false;
  }


  public submit(): void {
    if (this.userIdOrEmail) {
      this.clearMessages();
      this.observe(this.authenticateService.forgotPassword(this.userIdOrEmail), () => {
        this.submitted = true;
      });
    }
    else {
      this.logger.warn("how did submit get called with missing useridoremail");
    }
  }


  userIdKeydown() {
    this.isIdAvailable = false;
  }

  checkUsername(username: NgControl): Observable<boolean> {
    if (username.value?.length > 5) {
      return new Observable<boolean>(subscriber => {
        this.isIdAvailable = false;
        this.showSpinner = true;
        this.createAccountService.checkUserId(username.value).subscribe({
          next: (data) => {
            if (data.status === 'success' && data.userExists === false) {
              this.isIdAvailable = true;
            }
            if (data.status != 'success')
              this.processScrErrorResponse(data);
            subscriber.next(data.userExists ?? false);
          },
          error: (error) => {
            this.showSpinner = false;
            if (typeof error === 'string') {
              try {
                error = JSON.parse(error);
              }
              catch (e) {
                this.log.warn(e);
              }
            }
            if (error.status === 429) {
              error.message = 'Too many failed attempts on the User ID field. Please wait.';
            }
            this.processHttpError(error);
          },
          complete: () => {
            this.showSpinner = false;
          }
        });
      });
    } else {
      return of();
    }

  }

  validateToken() {
    const flow = this.router.url.includes('createcredentials') ? 'createcredentials' : '';
    this.observe(this.authenticateService.validatePassToken(this.model.token, flow), {
      onSuccess: (res) => {
        this.userId = res.userName;
        if (!this.userId) {
          this.showNoUserForm = true;
        } else {
          this.showForgotForm = true;
        }
        return false;
      },
      onError: () => {
        if (this.router.url.includes('createcredentials')) {
          // nothing to do.
        }
        else {
         this.token = undefined;
        }
      }
    });
  }

  submitPassword() {
    this.observe(this.authenticateService.setNewPassword(this.model), () => {
      this.scrServiceManager.emitChange({ type: 'success', code: 'scr.password.changed' });
      this.router.navigate(['sec/login']);
    });
  }

  submitCredentials() {
    this.observe(this.authenticateService.createCredentials(this.model), () => {
      this.scrServiceManager.emitChange({ type: 'success', code: 'scr.credentials.set' });
      this.router.navigate(['sec/login']);
    });
  }

}
